/* Components */
import Vue from 'vue';

import SideBar from './SideBar.vue';
Vue.component('SideBar', SideBar);

import SideBarGraphic from './SideBarGraphic.vue';
Vue.component('SideBarGraphic', SideBarGraphic);

import CurveText from './CurveText.vue';
Vue.component('CurveText', CurveText);

import ScrollListener from './ScrollListener.vue';
Vue.component('ScrollListener', ScrollListener);

import srcset from './srcset.vue';
Vue.component('srcset', srcset);

import ImageLoader from './ImageLoader.vue';
Vue.component('ImageLoader', ImageLoader);

import MainNavigation from './MainNavigation.vue';
Vue.component('MainNavigation', MainNavigation);

import close from './close.vue';
Vue.component('close', close);

import tags from './tags.vue';
Vue.component('tags', tags);

import gallery from './gallery.vue';
Vue.component('gallery', gallery);

import ImageRow from './ImageRow.vue';
Vue.component('ImageRow', ImageRow);

import MainFooter from './MainFooter.vue';
Vue.component('MainFooter', MainFooter);

import Spot from './spot.vue';
Vue.component('Spot', Spot);

import Link from './link.vue';
Vue.component('InOrOutLink', Link);

import Hamburger from './hamburger.vue';
Vue.component('Hamburger', Hamburger);

import heading from './heading.vue';
Vue.component('heading', heading);

import calendar from './calendar.vue';
Vue.component('calendar', calendar);

import pages from './pages.vue';
Vue.component('pages', pages);

import blocks from './blocks.vue';
Vue.component('blocks', blocks);

import veil from './veil.vue';
Vue.component('veil', veil);

import videoblock from './videoblock.vue';
Vue.component('videoblock', videoblock);
